module.exports = __webpack_public_path__ + "static/media/add-black.ecfc2593.svg";